export default {
	heading: 'Heading',
	body: 'Body',
	button: 'Button',
}